export function time_convert(totalSeconds) {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes} m ${seconds} s`;
}

export function time_convert_min_to_sec(num) {
  const hours = Math.floor(num / 60);
  const minutes = num % 60;
  return `${hours} h ${minutes} m`;
}
export function formatTime(seconds) {
  const date = new Date(seconds * 1000);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = pad(date.getUTCSeconds());
  if (hh) {
    return `${hh}h ${pad(mm)}m ${ss}s`;
  }
  return `${mm}m ${ss}s`;
}

export function formatSecondsDetailview(seconds) {
  const hours = Math.floor(seconds / 3600); // 1 hour = 3600 seconds
  const remainingAfterHours = seconds % 3600;
  const minutes = Math.floor(remainingAfterHours / 60); // 1 minute = 60 seconds
  const remainingSeconds = remainingAfterHours % 60;

  let result = '';
  if (hours > 0) result += `${hours}h `;
  if (minutes > 0) result += `${minutes}m `;
  // if (remainingSeconds > 0 || result === '') result += `${remainingSeconds}s`;

  return result.trim();
}

function pad(string) {
  return ('0' + string).slice(-2);
}
